import MuiAlert from '@mui/material/Alert';
import type { AlertProps as MuiAlertProps } from '@mui/material/Alert';
import { merge } from 'lodash';

interface CustomAlertProps extends MuiAlertProps {
  comp?: any;
}

export const Alert = (props: CustomAlertProps): React.ReactElement => {
  // const variant = props.variant || 'standard';
  // const severity = props.severity || 'info';

  // todo: add color for different variants
  const internalSx = {
    // ...comp?.alert[variant][severity],
    // '& .MuiAlert-icon': {
    //   color: comp?.alert[variant][severity].color,
    // },
  };

  const combinedSx = props.sx ? merge(props.sx, internalSx) : internalSx;

  return (
    <MuiAlert sx={combinedSx} {...props}>
      {props?.children || ''}
    </MuiAlert>
  );
};
